module.exports = __webpack_public_path__ + "static/media/squiggle-white.f83aefda.svg";